import React from "react";
import { connect } from "react-redux";
import DataTable from "../../components/Table";
import { getSmsEmailLogs } from "../../store/actions/smsEmailActions";
import ItemSelect from "../../components/SelectItemsPerPage/SelectItemsPerPage";

class SMSandEMAILlogs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            recordsPerPage: 10,
            currentPage: 1
        };
    }

    componentDidMount() {
        this.props.getSmsEmailLogs(1, 10);
    }

    selectPage = (pgNo) => {
        this.setState(
            {
                currentPage: pgNo
            },
            () => {
                this.props.getSmsEmailLogs(
                    this.state.currentPage,
                    this.state.recordsPerPage
                );
            }
        );
    };

    setMaxRecords = (size) => {
        this.setState(
            {
                recordsPerPage: size,
                currentPage: 1
            },
            () => {
                this.props.getSmsEmailLogs(
                    this.state.currentPage,
                    this.state.recordsPerPage
                );
            }
        );
    };

    render() {
        const { embedded = false } = this.props;
        const totalItems = this.props.smsEmailData?.smsEmaildata?.totalItems;
        const itemData = this.props.smsEmailData?.smsEmaildata;
        const logs = this.props.smsEmailData?.smsEmailLogs || [];

        const content = (
            <>
                {embedded && (
                    <h3 className="reports-tab-panel__title">CCM SMS & Email Logs</h3>
                )}

                {totalItems > 0 && (
                    <>
                        <div className="ccm-logs-page__toolbar inline-page-report">
                            <ItemSelect
                                itemsPerPage={this.state.recordsPerPage}
                                setItemsPerPage={this.setMaxRecords}
                            />
                        </div>

                        <div className="proposal-dashboard__table-section ccm-logs-page__table-section">
                            <DataTable
                                cellHeaders={[
                                    "ID",
                                    "Kafka Topic",
                                    "Proposal No",
                                    "Template Id",
                                    "Link",
                                    "Link1",
                                    "Link2",
                                    "Created On"
                                ]}
                                data={logs}
                                keys={[
                                    "id",
                                    "kafkaTopic",
                                    "proposalNo",
                                    "templateid",
                                    "link",
                                    "link1",
                                    "link2",
                                    "createdOn"
                                ]}
                                addSerialNo={true}
                                showExcelDownload={false}
                                PerPageApiData={true}
                                itemsPerPage={this.state.recordsPerPage}
                                currentPage={this.state.currentPage - 1}
                                setCurrentPage={this.selectPage}
                                alwaysShown={false}
                                paginationItems={itemData}
                            />
                        </div>
                    </>
                )}
            </>
        );

        if (embedded) {
            return <div className="reports-tab-panel">{content}</div>;
        }

        return (
            <div className="proposal-dashboard ccm-logs-page">
                <div className="proposal-dashboard__header ccm-logs-page__header">
                    <h2 className="proposal-dashboard__title">CCM SMS and Email Logs</h2>
                    <p className="proposal-dashboard__subtitle">
                        View CCM SMS and email dispatch logs
                    </p>
                </div>

                <div className="reports-page__content">{content}</div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        smsEmailData: state.smsEmailData,
        authentication: state.authentication
    };
};

export default connect(mapStateToProps, {
    getSmsEmailLogs
})(SMSandEMAILlogs);
